<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`退回`"
    width="600px"
    height="420px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" ref="editForm" :rules="rules" label-width="120px">
      <el-form-item label="报告编号">
        <el-input :value="activatedRow.reportCode" disabled></el-input>
      </el-form-item>
      <el-form-item label="检测项目">
        <el-input :value="activatedRow.sampleName" disabled></el-input>
      </el-form-item>
      <el-form-item v-if="isStage" label="退回到" prop="state">
        <el-radio-group v-model="editForm.state">
          <el-radio :label="-9">试验员</el-radio>
          <el-radio :label="-2">接样管理</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="退回原因" prop="reason">
        <el-input type="textarea" :rows="3" v-model="editForm.reason" placeholder="请输入" clearable></el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { editFlowState } from '@/api/audit';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activatedRow: {
      type: Object,
      default: () => ({})
    },
    // 是否需要选择退回节点
    isStage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      detailData: {},
      detailLoading: false,
      editForm: {
        state: null,
        reason: ''
      },
      rules: {
        state: [{ required: true, message: '请选择退回节点', trigger: 'change' }],
        reason: [{ required: true, message: '请输入退回原因', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm(`您确认要提交审核信息？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(async () => {
              this.submitLoading = true;
              const state = this.isStage ? this.editForm.state : -2;

              await editFlowState({ entrustmentId: this.activatedRow.entrustmentId, ...this.editForm, state });

              try {
                this.$message.success('退回成功！');
                this.$emit('refreshData'); // 回调刷新列表数据
                this.$emit('update:visible', false);
              } finally {
                this.submitLoading = false;
              }
            })
            .catch(() => {});
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.detail-wrap {
  height: calc(100% - 100px);
  margin-bottom: 20px;
  overflow: hidden;
  overflow-y: auto;

  .my-table {
    width: 100%;
  }
}
</style>
